import { Component, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ICCService } from '../icc.service';
import { ClrWizard } from '@clr/angular';
import { FleetConfiguration } from '../model/fleet-configuration';
import { NetworkProfile } from '../model/network-profile';
import { NETWORK_TYPES } from '../constants';
import { Util } from '../utils';

let _ = require('lodash');

@Component({
  selector: 'create-icc-wizard',
  styles: [require('../icc.scss')],
  template: require('./create-icc-wizard.html'),
  providers: [
    ICCService
  ]
})

export class CreateICCWizard {
    @ViewChild('wizard') wizard: ClrWizard;
    @Input() isWizardOpen: boolean = false;
    @Input() isEdit: boolean;
    @Input() orgVdcId: string = '';
    @Input() siteId: string = '';
    @Input() fleetConfig: FleetConfiguration;
    @Output() wizardStatusChange: EventEmitter<any> = new EventEmitter();
    @Output() AddEditOperationComplete:EventEmitter<any> = new EventEmitter();

    private reourceConfigCompleted: boolean = false;
    private networkConfigCompleted: boolean = false;
    private errorInNetworkConfig: boolean = false;
    private errorInResourceConfig: boolean = false;
    private errorInSave: boolean = false;
    private saveOperationInProgress: boolean = false;
    private errorMessage: string = '';
    private showDeleteNetworkProfileDialog: boolean = true;
    private staticRouteConfigCompleted: boolean = true;
    // public descVdcData1: any;
    private subscribeHandler;

    constructor(public service: ICCService) { }

    ngOnInit() {
    }

    ngOnChanges(changes) {
    }

    wizardStateChanged(isItOpen) {
      this.isWizardOpen = false;
      this.wizardStatusChange.emit(isItOpen);
      this.errorInSave = false;
      this.errorMessage = '';
    }

    isWizardOpenChange() {
    }

    toggleNextButton(event) {
      let fleetConfig:FleetConfiguration = event.fleetConfig;
      let stepId: number = event.stepId;
      if(stepId === 0){
        return Util.isResourceConfigCompleted(this.fleetConfig);
      }
    }

    private onValidateResourceConfiguration(){
      setTimeout(() => {
        this.onValidateResourceConfigurationTimer();
      }, 0);
    }

    private onValidateResourceConfigurationTimer(){
      this.reourceConfigCompleted = Util.isResourceConfigCompleted(this.fleetConfig);
    }

    private onNetworkProfileValidated(event){
      setTimeout(() => {
        this.networkConfigCompleted = event.isValid;
      }, 0);  
    }

    private validateFleetConfig(){
      // it is decided that all the validation will be done in the backend
      this.wizard.next();
    }

    private saveFleetConfiguration(){
      let fleetConfigSchemaObject = Util.convertToSchema(this.fleetConfig,this.siteId);
      this.saveOperationInProgress = true;
      if(this.fleetConfig.id !== ''){
        this.subscribeHandler = this.service.updateInterConnectConfig(fleetConfigSchemaObject,this.fleetConfig.vcenterInstanceId)
        .subscribe(
          (result) => {
            this.AddEditOperationComplete.emit();
            this.wizardStateChanged(false);
            this.errorInSave = false;
            this.errorMessage = '';
            this.saveOperationInProgress = false;
          },
          (error) => {
            this.errorInSave = true;
            this.errorMessage = Util.getErrorMessage(error);
            this.saveOperationInProgress = false;
          }
        ); 
      } else {
          this.subscribeHandler = this.service.createInterConnectConfig(fleetConfigSchemaObject,this.fleetConfig.vcenterInstanceId)
          .subscribe(
            (result) => {
              this.AddEditOperationComplete.emit();
              this.wizardStateChanged(false);
              this.errorInSave = false;
              this.errorMessage = '';
              this.saveOperationInProgress = false;
            },
            (error) => {
              this.errorInSave = true;
              this.errorMessage = Util.getErrorMessage(error);
              this.saveOperationInProgress = false;
            }
          ); 
        }
      }

      private onStaticRouteValidated(event){
        setTimeout(() => {
          this.staticRouteConfigCompleted = event.isValid;
        }, 0);  
      }

      private onStaticRouteCompleted(){
        this.wizard.next();
      }

      private onVCeneterChanged($evnet){
        let fleetConfig = new FleetConfiguration();
        fleetConfig.name = this.fleetConfig.name;
        fleetConfig.vcenterInstanceId = this.fleetConfig.vcenterInstanceId;
        // since vCenter has changed, entire fleet config has to be changed
        this.fleetConfig = fleetConfig;
        this.fleetConfig.networkProfiles.push(Util.getEmptyNetworkProfiles());
        this.onValidateResourceConfiguration();
      }
};



// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/wizard/create-icc-wizard.ts